import * as React from "react";
import {
  List, Datagrid, TextField, NumberField, BooleanField,
  Show, TabbedShowLayout, TextInput, ReferenceManyField,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { FrDateField } from "../../components/FrDateField";
import { UserRefField } from "../../components/ui";

// Lecture seule : création / modification / suppression d'une annonce sont
// réservées à son auteur côté backend (403 pour l'admin). Champs = ListingDTO.
// Seul filtre supporté par GET /listings : posterId.
const filters = [
  <TextInput key="posterId" source="posterId" label="ID auteur" alwaysOn />,
];

export default {
  list: () => (
    <List filters={filters} sort={{ field: "createdAt", order: "DESC" }}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="type" />
        <TextField source="posterName" label="Auteur" />
        <TextField source="city" label="Ville" />
        <NumberField locales="fr-FR" source="applicationCount" label="Candidatures" />
        <FrDateField source="createdAt" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Offre">
          <TextField source="type" />
          <TextField source="posterName" label="Auteur" />
          <UserRefField source="posterId" label="Auteur" />
          <TextField source="description" />
          <TextField source="cabinet" />
          <TextField source="city" label="Ville" />
          <TextField source="postalCode" label="Code postal" />
          <TextField source="startDate" label="Début" />
          <TextField source="endDate" label="Fin" />
          <TextField source="retrocession" label="Rétrocession" />
          <TextField source="patientsPerWeek" label="Patients / semaine" />
          <BooleanField source="lodging" label="Logement" />
          <BooleanField source="vehicleRequired" label="Véhicule requis" />
          <BooleanField source="hasSecretary" label="Secrétariat" />
          <BooleanField source="featured" label="Mise en avant" />
          <FrDateField source="createdAt" showTime />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Candidatures">
          <ReferenceManyField reference="listing-applications" target="listingId" label="">
            <Datagrid bulkActionButtons={false}>
              <TextField source="applicantName" label="Candidat" />
              <TextField source="message" label="Message" />
              <TextField source="status" />
              <FrDateField source="createdAt" label="Candidaté le" showTime />
            </Datagrid>
          </ReferenceManyField>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Brut">
          <JsonField source="__all__" />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  ),
};
